import { FC } from 'react';
import { Icons } from '@silverfort/sf-components';
import BlockPageMainImage from '../../assets/blockPageImage.png';
import { BlockPage, BlockPageProps } from '../../../../routings/pages/BlockPage/BlockPage';

const topics: BlockPageProps['rightContent']['topics'] = [
    'Automatically block threats before they reach critical resources.',
    'Strengthen resilience by blocking outdated protocols like NTLMv1.',
    'Prevent unauthorized access with precise user segmentation.',
    'Unlock Policy Insights to demonstrate security and close gaps.'
];

const AuthenticationFirewallBlockPage: FC = () => {
    return (
        <BlockPage
            leftContent={{
                title: 'Authentication Firewall',
                image: BlockPageMainImage
            }}
            rightContent={{
                topics,
                icon: Icons.Shield,
                accessLink: 'https://www.silverfort.com/firewall-signup/?utm_source=PQL&utm_content=locked',
                title: 'Discover Authentication Firewall',
                description: 'Stop risky access and prove your protection with powerful deny policies.',
                badgeProps: {
                    text: 'License Upgrade',
                    color: 'positive'
                }
            }}
        />
    );
};

export default AuthenticationFirewallBlockPage;
